<template>
  <div
    :class="[
      'py-4',
      position !== 4 ? 'border-b-[1px] border-neutral-200 dark:border-neutral-800' : '',
    ]"
  >
    <div class="flex gap-2 items-center">
      <UChip
        v-if="position <= 2"
        inset
        position="bottom-left"
        :text="`Top ${position + 1}`"
        size="xl"
        color="error"
        :ui="{
          base: 'p-1',
        }"
      >
        <UAvatar :src="author.avatar" :alt="fullName" size="lg" loading="lazy" />
      </UChip>
      <UAvatar v-else :src="author.avatar" :alt="fullName" size="lg" loading="lazy" />

      <div class="flex flex-col items-start">
        <UButton
          color="error"
          class="font-semibold"
          variant="link"
          :to="`/users/${author.username}`"
          :padded="false"
          >{{ fullName }}</UButton
        >
        <span class="text-xs text-neutral-500">{{ author.username }}</span>
      </div>
    </div>
    <div class="flex w-full justify-around mt-2">
      <UButton
        icon="i-heroicons-eye"
        size="xs"
        color="white"
        variant="soft"
        :trailing="false"
        :padded="false"
        >{{ formatCompactNumber(author.views) }}</UButton
      >
      <UButton
        icon="i-heroicons-bookmark"
        size="xs"
        color="white"
        variant="soft"
        :trailing="false"
        :padded="false"
        >{{ author.bookmarks }}</UButton
      >
      <UButton
        icon="i-heroicons-document-chart-bar"
        size="xs"
        color="white"
        variant="soft"
        :trailing="false"
        :padded="false"
        >{{ author.articles }}</UButton
      >
      <UButton
        icon="i-heroicons-hand-raised"
        size="xs"
        color="white"
        variant="soft"
        :trailing="false"
        :padded="false"
        >{{ author.claps }}</UButton
      >
    </div>
    <UButton
      v-if="isFollowed && userStore?.id !== author?.id"
      icon="i-heroicons-check-circle"
      color="neutral"
      variant="subtle"
      :label="LL.followed()"
      size="xs"
      class="mt-2"
      block
      :loading="isLoading"
      @click="handleFollowUser(false)"
    />
    <UButton
      v-if="!isFollowed && userStore?.id !== author?.id"
      icon="i-heroicons-bell-alert"
      color="neutral"
      variant="soft"
      :label="LL.follow()"
      size="xs"
      class="mt-2"
      block
      :loading="isLoading"
      @click="handleFollowUser(true)"
    />
  </div>
</template>

<script lang="ts" setup>
import { postFollowUser } from "features/post-action";
import { useUserStore } from "~/store";
import { typesafeI18n } from "~/locales/i18n-vue";
import { formatCompactNumber } from "~/utils/number";

const { LL } = typesafeI18n();
const userStore = useUserStore();

const props = defineProps({
  author: {
    type: Object,
    required: true,
  },
  position: {
    type: Number,
    required: true,
  },
});

const isFollowed = ref(props.author.is_followed);
const isLoading = ref(false);

const handleFollowUser = (followed: boolean) => {
  userStore.checkIsLogged(LL.value.you_need_to_login_to_action(), async () => {
    isLoading.value = true;
    const { error } = await postFollowUser({
      username: props.author.username,
    });
    if (error.value?.data) {
      isLoading.value = false;
    } else {
      isFollowed.value = followed;
      isLoading.value = false;
    }
  });
};

const fullName = computed(() => `${props.author.firstName} ${props.author.lastName}`);
</script>
